export default Object.freeze({
  SERVING: ['ADF', 'Currently serving', 'adf', 'currently serving', 'Currently Serving'],
  EX_SERVING: ['ExServing', 'Ex-serving', 'exserving', 'ex-serving', 'Ex-Serving'],
  WORK_CONNECTION: ['WorkConnection', 'workconnection', 'Work Connection', 'work connection'],
  RELATED: ['Supporting', 'supporting', 'Relatives', 'relatives'],
});
